import React from 'react';
import georgeKoladeImg from '../assets/peopleInvolved/george.kolade.png';
import zhangLiImg from '../assets/peopleInvolved/zhang.li.png';
import ezeLukeImg from '../assets/peopleInvolved/eze.luke.png';

const PeopleInvolved = () => {
  const teamMembers = [
    {
      name: "George Samuel Akolade",
      role: "Founder & CEO",
      bio: "Innovative tech leader passionate about empowering merchants, simplifying trade, and driving Africa's digital commerce growth.",
      image: "https://checkstall-storage.s3.eu-west-1.amazonaws.com/peopleInvolved/george.kolade.png"
    },
    {
      name: "Zhang Li",
      role: "China Warehouse Manager",
      bio: "Oversees all China-based operations, managing receiving, packaging, and shipment processes to ensure efficient handling and timely delivery. Dedicated to maintaining quality control and smooth logistics coordination between suppliers and international customers.",
      image: "https://checkstall-storage.s3.eu-west-1.amazonaws.com/peopleInvolved/zhang.li.png"
    },
    {
      name: "Eze Luke Nchekwube",
      role: "Southeast Operations Lead",
      bio: "Oversees all China-based operations, managing receiving, packaging, and shipment processes to ensure efficient handling and timely delivery. Dedicated to maintaining quality control and smooth logistics coordination between suppliers and international customers.",
      image: "https://checkstall-storage.s3.eu-west-1.amazonaws.com/peopleInvolved/eze.luke.png"
    }

  ];

  const advisors = [
    // {
    //   name: "Dr. Ngozi Okonjo-Iweala",
    //   role: "Strategic Advisor",
    //   bio: "Former Director-General of WTO and Finance Minister of Nigeria. Provides strategic guidance on international trade.",
    //   image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&crop=face"
    // },
    // {
    //   name: "Prof. Wang Li",
    //   role: "China Trade Advisor",
    //   bio: "Professor of International Business at Peking University. Expert in China-Africa trade relations.",
    //   image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face"
    // }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary-50 to-white py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
              People <span className="text-primary">Involved</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Meet the passionate team and advisors behind Checkstall's mission to transform international trade
            </p>
          </div>
        </div>
      </section>

      {/* Core Team */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Our Core Team</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              The dedicated professionals working to make Checkstall the leading platform for international trade
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-soft-lg overflow-hidden hover:shadow-soft-lg transition-shadow duration-300">
                <div className="aspect-w-1 aspect-h-1">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-64 object-cover"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">{member.name}</h3>
                  <p className="text-primary font-medium mb-4">{member.role}</p>
                  <p className="text-gray-600 text-sm leading-relaxed">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advisors */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Our Advisors</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Industry experts and thought leaders guiding our strategic direction
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {advisors.map((advisor, index) => (
              <div key={index} className="bg-gray-50 rounded-2xl p-8 hover:shadow-soft transition-shadow duration-300">
                <div className="flex flex-col md:flex-row items-center md:items-start space-y-4 md:space-y-0 md:space-x-6">
                  <img
                    src={advisor.image}
                    alt={advisor.name}
                    className="w-24 h-24 rounded-full object-cover flex-shrink-0"
                  />
                  <div className="text-center md:text-left">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">{advisor.name}</h3>
                    <p className="text-primary font-medium mb-3">{advisor.role}</p>
                    <p className="text-gray-600 text-sm leading-relaxed">{advisor.bio}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Join Our Team */}
      <section className="py-16 md:py-24 bg-primary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Join Our Mission
          </h2>
          <p className="text-xl text-primary-100 mb-8 max-w-3xl mx-auto">
            We're always looking for passionate individuals who want to make a difference in international trade
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/careers"
              className="bg-white text-primary px-8 py-3 rounded-2xl font-semibold hover:bg-gray-50 transition-colors duration-200"
            >
              View Open Positions
            </a>
            <a
              href="/contact"
              className="border-2 border-white text-white px-8 py-3 rounded-2xl font-semibold hover:bg-white hover:text-primary transition-colors duration-200"
            >
              Get in Touch
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PeopleInvolved;


